import React, { useState } from 'react';
import ReactModal from 'react-modal';

import '../styles/modal.css';

import Hero from '../components/hero';
import Opener from '../components/home/opener';
// import Offer from '../components/home/offer';
import Facts from '../components/home/facts';
import Learn from '../components/home/learn';
import ProgramsCarousel from '../components/global/programs-carousel';
import Testimonials from '../components/testimonials';
import Form from '../components/home/form';
import ContestMasthead from '../components/home/contest-mast';

import mailgunSubmitForm from '../util/mailgunSubmitForm';

export default ({ copy, offerData }) => {
	ReactModal.setAppElement('#___gatsby');

	const [isModalOpen, setModalOpen] = useState(false);

	const [message, setMessage] = useState(null);
	const [errorMessage, setErrorMessage] = useState(null);

	const closeModal = () => {
		setModalOpen(false);
		setTimeout(() => setMessage(''), 500);
	};

	return (
		<>
			{/* Toggle contest or reg mastheads based on hasContest boolean set in index.json */}
			{/* TODO: Add setting of images and link to index.json to make contest mashead more maintainable */}
			{!!copy.hero.hasContest ? (
				<ContestMasthead />
			) : (
				<Hero
					title={copy.hero.title}
					bimg={copy.hero.bimg}
					subtext={copy.hero.subtext}
					cta={copy.hero.cta}
				/>
			)}

			<Opener data={copy.opener} />
			<Testimonials />
			{/* <Offer setModalOpen={setModalOpen} offerData={offerData} /> */}
			<Learn data={copy.learn} />
			<Facts data={copy.facts} />
			<ProgramsCarousel />
			<Form title={copy.form.title} />
			<ReactModal
				isOpen={isModalOpen}
				contentLabel="onRequestClose Example"
				onRequestClose={closeModal}
				className="Modal"
				overlayClassName="Overlay"
				closeTimeoutMS={500}
			>
				<h2>Special Offer</h2>
				{message && (
					<div className="thanks">
						<h2>Thanks for submitting.</h2>
						<p>{message}</p>
					</div>
				)}
				{!message && (
					<form
						action="/.netlify/functions/form-submit/"
						onSubmit={(event) =>
							mailgunSubmitForm(event, setMessage, setErrorMessage)
						}
						name="Home Page Popup Form"
					>
						<input type="hidden" name="formName" value="Home Page Popup Form" />
						<label htmlFor="name">Name:</label>
						<input name="name" required type="text" id="name" />

						<label htmlFor="phone">Phone:</label>
						<input type="text" id="phone" name="phone" />

						<label htmlFor="email">Email:</label>
						<input required type="email" id="email" name="email" />

						<label htmlFor="message">Message:</label>
						<textarea id="message" name="message" />

						<button className="submit-button">Submit</button>
					</form>
				)}
				{errorMessage && <div className="error-message">{errorMessage}</div>}
				<button className="close-button" onClick={closeModal}>
					<img src="/img/times.svg" alt="x" />
				</button>
			</ReactModal>
		</>
	);
};
